export default __webpack_public_path__ + "static/media/me-icon.48ee2108.webp";